import React from 'react';
import { useTranslation } from 'react-i18next';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';

interface FormTabsProps {
  tab: 'templateDetails' | 'headerMapping';
  add?: boolean;
  onTabChange: (event: React.SyntheticEvent, newValue: 'templateDetails' | 'headerMapping') => void;
}

const FormTabs: React.FC<FormTabsProps> = ({ tab, add, onTabChange }) => {
  const { t } = useTranslation();

  return (
    <div className="card-header overflow-hidden no-padding">
      <Tabs value={tab} onChange={onTabChange} textColor="primary">
        <Tab value="templateDetails" label={t('templates.addEdit.pageTexts.tabs.templateDetails', 'Template Details')} />
        {!add && <Tab value="headerMapping" label={t('templates.addEdit.pageTexts.tabs.headerMapping', 'Header Mapping')} />}
      </Tabs>
    </div>
  );
};

export default FormTabs;
